export default "__VITE_PUBLIC_ASSET__6909e2a5__"